import ReferralMiddleware from './ReferralMiddleware'

export default ReferralMiddleware
